import { Injectable } from '@angular/core';
import { DocumentCollection, Resource } from 'ngx-jsonapi';
import { BehaviorSubject, filter, map, Observable } from 'rxjs';
import { JsonapiWebsocketHelper } from './jsonapi-websocket.helper';

export interface ITransactionPrivateChannelParams {
    transactionKey: string;
    transactionMid: string;
    transactionId: string;
}

@Injectable({
    providedIn: 'root'
})
export class JsonapiWebsocketService {
    private websocketEvent$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    private jsonapiHelper: JsonapiWebsocketHelper = new JsonapiWebsocketHelper();

    public onResource<T extends Resource>(resourceType: string, resourceId: string = ''): Observable<T> {
        return this.websocketEvent$.pipe(
            filter((eventData) => eventData !== null),
            filter((eventData) => this.jsonapiHelper.isResource(eventData)),
            filter((eventData) => {
                return resourceType === '' || eventData.data.type === resourceType;
            }),
            map((eventData) => {
                return this.jsonapiHelper.generateResourceFromEvent(eventData);
            }),
            map((resource) => {
                return resource as T;
            }),
            filter((resource: T) => {
                if (!resourceId) {
                    return true;
                }

                return resource.id === resourceId;
            })
        );
    }

    public onDocumentCollection<T extends Resource>(resourceType: string): Observable<DocumentCollection<T>> {
        return this.websocketEvent$.pipe(
            filter((eventData) => {
                return eventData !== null;
            }),
            filter((eventData) => {
                return (
                    eventData.data && Array.isArray(eventData.data) && eventData.data.length > 0 && eventData.data[0]?.type === resourceType
                );
            }),
            map((eventData) => {
                const processed: any = this.jsonapiHelper.processWebSocketEvent(eventData);

                return processed;
            }),
            filter((processedData) => {
                return processedData !== null;
            }),
            filter((eventData) => {
                const isNotResource: boolean = !this.jsonapiHelper.isResource(eventData);

                return isNotResource;
            })
        );
    }

    public pushEvent(eventData: any): void {
        this.websocketEvent$.next(eventData);
    }
}
